<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Clientes del Restaurante " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-spacer />
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :items="clientesList" :loading="loading">
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
import { idToTexto } from "@/utils/utils.js";

export default {
  data() {
    return {
      id: null,
      nombreMostrar: "",
      email: "",
      telefono: "",
      direcciones: [],
      loading: false,
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "displayName",
        },
        {
          sortable: false,
          text: "Telefono",
          value: "phoneNumber",
        },
        {
          sortable: false,
          text: "Restaurantes",
          value: "restaurantes",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      negocio: "app/negocioGestObj",
      clientesListBruto: "restaurantes/getClientesList",
    }),
    clientesList() {
      return this.clientesListBruto.map((c) => {
        return {
          ...c,
          restaurantes: idToTexto(c.restaurantes.join(",")),
        };
      });
    },
    ...mapState({
      clientes: (state) => state.clientes.clientesArray,
      restaurantes: (state) => state.app.restaurantesArray,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de clientes ";
    },
    formTitle() {
      return this.isEdit ? "Editar Cliente" : "Nuevo Cliente";
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },
    reload() {
      this.getClientes();
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    editItemDialog(item) {
      this.nombreIdiomas = JSON.parse(JSON.stringify(item.nombre));
      this.descripcionIdiomas = JSON.parse(JSON.stringify(item.descripcion));
      this.showDialog();
      this.id = item.id;
    },
    getClientes() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("restaurantes/getClientesRestauranteCall")
        .finally(() => {
          _vm.loading = false;
        });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      (this.id = null),
        (this.nombreMostrar = ""),
        (this.email = ""),
        (this.telefono = ""),
        (this.direcciones = []),
        this.$store.commit("setLangSeleccionadoDefecto");
    },
  },
};
</script>

<style>
</style>